import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { MedicineJSONAModel } from "interfaces/jsona-models/MedicineJSONAModel";

export class MedicineSelector extends BaseApiSelector<MedicineJSONAModel> {
  constructor() {
    super(ResourceType.Medicine);
  }
}
